export const affordabilityDisclaimerText =
  'Product disclaimer: Legal & General Ignite is designed for professional use by mortgage intermediaries for ' +
  'guidance purposes only. Any output of the Legal & General Ignite system shall not constitute a commitment to lend ' +
  '. The selection of mortgage product could influence the \'Maximum Affordable Loan\' amount that could be borrowed';

export const initialProductLengthTooltip = `
  <p>The length of the product being taken out by the applicant.</p>${affordabilityDisclaimerText}
`;
